export default {"src":"/hedera/_next/static/media/terra.5f74e6a9.svg","height":14,"width":14};